import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrending5"><Path d="M19.4375 10.9375L17.3125 8.8125L12 14.125L9.34375 11.4688L3.8125 17M3.5 3.5V20.5H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrending5;
